import React from 'react';
import Tippy from '@tippyjs/react';

import styled from '../consts/styled';

const Container = styled.div`
  position: relative;

  &:hover {
    cursor: pointer;
  }

  .blinking {
    animation: blink 1s infinite;
  }

  .blinking2 {
    position: absolute;
    left: 0;
    top: 0;
    animation: blink2 1s infinite;
  }

  @keyframes blink {
    from {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(2);
      opacity: 1;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes blink2 {
    from {
      transform: scale(0);
      opacity: 1;
    }
    50% {
      transform: scale(1.5);
      opacity: 1;
    }
    to {
      transform: scale(0);
      opacity: 1;
    }
  }
`;

interface DotInfoProps {
  style?: React.CSSProperties;
  info?: string;
  onClick?: () => void;
}

const DotInfo = (props: DotInfoProps) => {
  const { style, info, onClick } = props;
  return (
    <Tippy arrow={true} theme="light" animation="scale" content={info}>
      <Container
        style={style}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <svg height="48" width="48" className="blinking">
          <circle cx="24" cy="24" r="5" fill="red" />
        </svg>
        <svg height="48" width="48" className="blinking2">
          <circle cx="24" cy="24" r="5" fill="white" />
        </svg>
      </Container>
    </Tippy>
  );
};

export default DotInfo;
